import { Component, OnInit } from '@angular/core';
import {
  Title,
  Meta,
  SafeResourceUrl,
  DomSanitizer,
} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { PromoPage } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { NgIf, NgFor } from '@angular/common';
import { PageComponent } from '../page/page.component';
import { Link } from '../../../interfaces/strapi';
import { CmsLinkComponent } from '../cms-link/cms-link.component';
import { TabsSliceComponent } from '../tabs-slice/tabs-slice.component';

@Component({
    selector: 'app-marketing-page',
    templateUrl: './marketing-page.component.html',
    styleUrls: ['./marketing-page.component.scss'],
    imports: [
        NgIf,
        CmsLinkComponent,
        NgFor,
        TabsSliceComponent,
    ],
})
export class MarketingPageComponent extends PageComponent implements OnInit {
  public override pageData: PromoPage = <PromoPage>{};

  public cta!: Link;

  constructor(
    protected override readonly titleService: Title,
    protected override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    private readonly route: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    private readonly router: Router
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit() {
    const promoUID = this.route.snapshot.paramMap.get('promoUID');

    if (promoUID) {
      this.strapi
        .getDocumentByUID('marketing-content-pages', promoUID, {
          populate: '*',
        })
        .subscribe({
          next: (data: any) => {
            if (data.data.length) {
              this.parsePageData(data.data[0].attributes as PromoPage);
              super.setMetas();
            } else {
              this.router.navigate(['/page-not-found']).finally(() => false);
            }
          },
          error: () => {
            this.router.navigate(['/page-not-found']).finally(() => false);
          },
        });
    }
  }

  protected override parsePageData(page: PromoPage): void {
    const theData = page;

    super.parsePageData(page);

    this.pageData = theData;

    this.cta = <Link>{
      label: this.pageData.cta_text,
      link: this.pageData.cta,
      route: this.pageData.cta_route,
    };
  }

  public youtubeUrl(): SafeResourceUrl {
    const videoId = String(this.pageData.video_id);
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${videoId}`
    );
  }
}
